/* src/app/components/HeaderBar/index.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import {
  AppBar,
  IconButton,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { Menu } from '@material-ui/icons';

import styles from './styles';

const HeaderBar = ({ classes, onToggle, disableMenu, children, title }) => (
  <AppBar className={classes.bar} position="sticky">
    <Toolbar>
      <IconButton
        onClick={onToggle}
        className={classes.menuButton}
        color="inherit"
        aria-label="Menu"
        disabled={disableMenu}
      >
        <Menu />
      </IconButton>
      <Typography
        noWrap
        variant="title"
        color="inherit"
        className={classes.flex}
      >
        {title}
      </Typography>
      {children}
    </Toolbar>
  </AppBar>
);

HeaderBar.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any,
  onToggle: PropTypes.func.isRequired,
  disableMenu: PropTypes.bool,
};

HeaderBar.defaultProps = {
  disableMenu: false,
  children: null,
};

export default withStyles(styles)(HeaderBar);



// WEBPACK FOOTER //
// ./src/app/components/HeaderBar/index.js